import React, { useState } from "react";
import "./FAQ.css";

const faqs = [
  { question: "What countries do you export to?", answer: "We export to various countries across Asia, Europe, and North America." },
  { question: "How long does shipping take?", answer: "Shipping takes 2-6 weeks depending on the destination." },
  { question: "Are there any additional charges?", answer: "Customs and import duties may apply based on the destination country." }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item" onClick={() => setOpenIndex(index === openIndex ? null : index)}>
            <div className="faq-question">{faq.question}</div>
            {openIndex === index && <div className="faq-answer">{faq.answer}</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
